const toPositiveHeight = value => {
    const height = Math.ceil(Number(value || 0))
    return Number.isFinite(height) && height > 0 ? height : null
}

const getScrollContainerHeight = scrollContainer => {
    const clientHeight = toPositiveHeight(scrollContainer?.clientHeight)
    if (clientHeight) return clientHeight

    return toPositiveHeight(scrollContainer?.getBoundingClientRect?.()?.height)
}

export const shouldAllowNonAnchoringReservedHeightShrink = ({
    scrollContainer,
    rowTop,
    reservedHeight,
}) => {
    const top = Number(rowTop)
    const height = toPositiveHeight(reservedHeight)
    const viewportHeight = getScrollContainerHeight(scrollContainer)

    if (!Number.isFinite(top) || !height || !viewportHeight) return false

    return top + height > 1
}

export const resolveReservedHeight = ({
    measuredHeight,
    previousHeight = 0,
    previousMeasuredHeight = 0,
    hasMeasuredHeight = false,
    preserveHeight = false,
    allowShrink = false,
    minHeight = 1,
}) => {
    const nextMeasuredHeight = toPositiveHeight(measuredHeight)
    const minimumHeight = toPositiveHeight(minHeight) || 1

    if (!nextMeasuredHeight && !preserveHeight) return null

    const previousReservedHeight = Math.max(
        toPositiveHeight(previousHeight) || 0,
        toPositiveHeight(previousMeasuredHeight) || 0,
        minimumHeight,
    )

    if (preserveHeight || (hasMeasuredHeight && !allowShrink)) {
        return Math.max(nextMeasuredHeight || 0, previousReservedHeight)
    }

    return Math.max(nextMeasuredHeight || 0, minimumHeight)
}

export const compensateScrollForMeasurementChange = ({
    scrollContainer,
    previousHeight,
    previousTop,
    nextHeight,
    nextTop,
}) => {
    const delta = Number(nextHeight || 0) - Number(previousHeight || 0)
    if (
        !scrollContainer ||
        Math.abs(delta) <= 1 ||
        !Number.isFinite(nextTop) ||
        !Number.isFinite(previousTop)
    ) {
        return { applied: false, delta }
    }

    const estimatedPreviousBottom = previousTop + Number(previousHeight || 0)
    const wasAboveViewport = estimatedPreviousBottom <= 1
    const alreadyCompensated = Math.abs(nextTop - (previousTop - delta)) <= 2
    const isMovingBackTowardRow = nextTop > previousTop + 2

    if (wasAboveViewport && !alreadyCompensated && !isMovingBackTowardRow) {
        scrollContainer.scrollTop += delta
        return { applied: true, delta }
    }

    return { applied: false, delta }
}
